(function () {
  'use strict';

  angular
    .module('minilogin', [])

    /* @ngInject */
    .directive('miniLogin', function () {
      return {
        restrict: 'E',
        bindToController: {
          titleLogin: '@',
          titleLogout: '@'
        },
        controllerAs: 'miniLoginCtrl',
        /* @ngInject */
        controller: ["$scope", "$rootScope", "$element", "$document", "$location", "$route", "$window", "toastr", "AccountService", "LogService", "AppService", "HttpService", function ($scope, $rootScope, $element, $document, $location, $route, $window, toastr, AccountService, LogService, AppService, HttpService) {
          var ctrl = this;

          ctrl.links = AccountService.getLinks();

          update();

          var $body = $(document.body);
          $body.addClass('offcanvas');

          ctrl.toggle = function () {
            toggle();
          };

          ctrl.logout = function () {
            ctrl.isLogged = false;
            toggle();
            $rootScope.$broadcast('showPageLoader', true);
            HttpService.post({
              url: 'Cart/ClearCart',
              data: {}
            })
            LogService.logout()
              .then(function (response) {
                if (response.status === 'OK') {
                  AppService.updateParams(_.merge(response.VisitorContext, { IsLogged: false }));
                  $rootScope.$broadcast('logUpdate', false);
                  update();
                  toastr.success('', ctrl.titleLogout, {
                    allowHtml: true,
                    extraData: {
                      template: 'toast_authentication.tpl'
                    }
                  });
                  if ($route.current && $route.current.resolve && $route.current.resolve.authorize) {
                    $location.path('/');
                  } else {
                    $window.location.reload();
                  }
                }
                $rootScope.$broadcast('showPageLoader', false);
              })
              .catch(function (error) {
                console.error(error);
              });
          };

          // Functions

          $scope.$on('userUpdate', function () {
            update(true);
          });

          $scope.$on('logUpdate', function (event, value) {
            if (value) {
              toastr.success('', ctrl.titleLogin, {
                allowHtml: true,
                extraData: {
                  template: 'toast_authentication.tpl'
                }
              });
            }
            update();
          });

          // Functions

          function toggle() {
            if ($body.hasClass('offcanvas-right')) {
              $body.removeClass('offcanvas-right');
              $document.off('click', onBodyClick);
            } else {
              $body.addClass('offcanvas-right');
              $document.on('click', onBodyClick);
            }
          }

          function onBodyClick(event) {
            if (!$element[0].contains(event.target)) {
              toggle();
            }
          }

          function update(refresh) {
            AppService.getParams(refresh)
              .then(function (params) {
                ctrl.isLogged = params.IsLogged;
                if (ctrl.isLogged) {
                  ctrl.visitor = params.Visitor.FullName;
                }
                AccountService.setManagement(ctrl);
                if (refresh) {
                  $rootScope.$broadcast('cartUpdate');
                }
              })
              .catch(function (error) {
                console.error(error);
              });
          }
        }]
      };
    });

})();
